'use client';

import { useTranslations } from 'next-intl';
import type { FC } from 'react';
import { BaseLineCoupon } from '@/app/components/icons/BaseLineCoupon';
import { formatPriceDiscount } from '@/app/utils';
import { useLocale } from '@/i18n/routing';

/**
 * 优惠券折扣角标——紫色胶囊样式
 *
 * 用于商品卡片右上角展示已选优惠券的折扣百分比，统一 PlanCard / PassCard /
 * CreditsItem 三处之前的复制粘贴 JSX。样式不可改，与设计稿对齐。
 *
 * @param discount percentOff，例如 20 表示 20% off / 8 折
 */
export const CouponBadge: FC<{ discount: number }> = ({ discount }) => {
  const t = useTranslations();
  const locale = useLocale();

  return (
    <div className="relative flex h-[25px] items-center gap-1 rounded-8 border border-[#6366f1] bg-[rgba(99,102,241,0.4)] px-2">
      <BaseLineCoupon className="size-4 shrink-0 text-white" />
      <div className="font-bold text-white text-xs uppercase italic leading-[1.4]">
        {t('popup.dialog.purchaseCredits.discountText', {
          discount: formatPriceDiscount(discount, locale),
        })}
      </div>
    </div>
  );
};
